export enum Ambiente {
  PROD = 'produção',
  HML = 'homologação',
  LOCAL = 'local',
  DEV = 'dev'
}
